import { Box, FormControlLabel, Radio, Typography } from "@mui/material";

interface RadioCardProps {
  value: string;
  label: string;
  selected: boolean;
  disabled?: boolean;
}

export function RadioCard({
  value,
  label,
  selected,
  disabled = false
}: RadioCardProps) {
  return (
    <Box
      sx={{
        border: "2px solid",
        borderColor: selected ? "primary.main" : "grey.300",
        borderRadius: 2,
        px: 1,
        py: 0.5,
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "border-color 0.15s ease",
        "&:hover": {
          borderColor: selected ? "primary.main" : "grey.400"
        }
      }}
    >
      <FormControlLabel
        value={value}
        control={
          <Radio
            disabled={disabled}
            icon={
              <Box
                sx={{
                  width: "22px",
                  height: "22px",
                  borderRadius: "50%",
                  border: "2px solid",
                  borderColor: "grey.400",
                  boxSizing: "border-box"
                }}
              />
            }
            checkedIcon={
              <Box
                sx={(theme) => ({
                  width: "22px",
                  height: "22px",
                  borderRadius: "50%",
                  border: `2px solid ${theme.palette.primary.main}`,
                  background: `radial-gradient(circle, white 38%, ${theme.palette.primary.main} 38%)`,
                  boxSizing: "border-box"
                })}
              />
            }
          />
        }
        label={<Typography variant="body1">{label}</Typography>}
        sx={{ width: "100%", m: 0 }}
      />
    </Box>
  );
}
